import React, { useState } from 'react';
import { useAppSocketContext } from '@/shared/hooks';
import { useNavigate } from 'react-router-dom';
import ChangeProfileModal from './ChangeProfileModal';
import ProfileMenu from './ProfileMenu';
import type { User } from '@/shared/types';
import { AUTH, type AuthState } from "@/shared/constants/auth";

function Header({user, refetchUser, setAuthState, game } : {user: User | null, refetchUser: () => void, setAuthState: (state: AuthState) => void, game: string}){
  const navigate = useNavigate();
	const { isConnected } = useAppSocketContext();
	const [profileHovered, setProfileHovered] = useState(false);
  const [profileSettingSelected, showChangeProfileSettingsModal] = useState<string | null>(null);

	return (
    <header className="header">
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div data-cy="connection-circle" className={`connectionCircle ${isConnected ? "connected" : "disconnected"}`}></div>
      <div
      onClick={() => navigate('/')}
      style={{ cursor: 'pointer', marginTop: '2px' }}
      >
      {`GH${game === 'none-bck' ? '' : game}`.toUpperCase()}
      </div>
    </div>
    <div className="account-center">
      <button
        onClick={() => window.open('https://discord.gg/CQfyBqmdW', '_blank')}
        style={{ display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
        title="Join our Discord"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ paddingTop: "2px" }}
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7" />
        </svg>
      </button>
      <div className="border"></div>
      <div
        onMouseEnter={() => setProfileHovered(true)}
        style={{ position: 'relative', display: 'inline-block' }}
      >
      {user ? (
          <button data-cy="profile-btn" style={{ cursor: 'pointer' }}>{user.username}</button>
      ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <button data-cy="sign-up-btn" onClick={() => setAuthState(AUTH.REGISTER)}>Sign up</button>
              <div className="border"></div>
              <button data-cy='log-in-btn' onClick={() => setAuthState(AUTH.LOGIN)}>Log in</button>
          </div>
      )}
    </div>
  </div>
  {user && profileHovered &&
   <div style={{ 
    position: 'absolute',
    top: '31px',
    right: 0, 
    }} 
    onMouseLeave={() => setProfileHovered(false)}
   >
    <ProfileMenu user={user} profileHovered={profileHovered} showChangeProfileSettingsModal={showChangeProfileSettingsModal} />
    </div>
  }
    {profileSettingSelected && (
              <ChangeProfileModal
                setting={profileSettingSelected}
                showChangeProfileSettingsModal={showChangeProfileSettingsModal}
                registeredEmail={user?.email ?? ""}
                registeredPlatform={user?.platform ?? ""}
                registeredPlatformUsername={user?.platformUsername ?? ""}
                refetchUser={refetchUser}
              />
      )}
  </header>
	);
}

export default Header;
